import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Mail, MapPin, Phone } from "lucide-react";
import EnquiryForm from "./EnquiryForm";

export const DETAILS = [
  { icon: Phone, label: "Private Line", value: "+91 89178 89178", testId: "contact-phone-detail" },
  { icon: Mail, label: "Write to Us", value: "bespoke@modimarine.com", testId: "contact-email-detail" },
  { icon: MapPin, label: "Presence", value: "Pan-India · By Appointment", testId: "contact-address-detail" },
];

export default function Contact() {
  const [presetInterest, setPresetInterest] = useState("");

  useEffect(() => {
    const apply = (interest) => {
      if (!interest) return;
      setPresetInterest(interest);
      sessionStorage.removeItem("mm_interest");
    };
    apply(sessionStorage.getItem("mm_interest"));
    const onEvent = (e) => apply(e.detail);
    window.addEventListener("mm-interest", onEvent);
    return () => window.removeEventListener("mm-interest", onEvent);
  }, []);

  return (
    <section id="contact" className="relative border-t border-navy-ink/5 bg-navy px-6 py-20 lg:px-12 lg:py-28" data-testid="contact-section">
      <div className="mx-auto max-w-7xl">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-6 text-[10px] uppercase tracking-[0.45em] text-gold sm:text-xs"
          data-testid="contact-overline"
        >
          05 — Contact Us
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="max-w-2xl font-serif text-4xl font-light leading-[1.05] tracking-tight text-navy-ink sm:text-5xl lg:text-6xl"
          data-testid="contact-heading"
        >
          Begin the
          <span className="italic text-gold-light"> conversation.</span>
        </motion.h2>

        <div className="mt-20 grid gap-16 lg:grid-cols-12 lg:gap-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8 }}
            className="space-y-10 lg:col-span-5"
            data-testid="contact-details"
          >
            <p className="max-w-sm text-sm font-light leading-relaxed text-mist">
              Every enquiry is answered personally by our private office.
              Discretion is assured; introductions are by appointment.
            </p>
            {DETAILS.map((d) => (
              <div key={d.label} className="flex items-start gap-5" data-testid={d.testId}>
                <d.icon size={20} strokeWidth={1} className="mt-1 text-gold" />
                <div>
                  <p className="text-[10px] uppercase tracking-[0.3em] text-mist">{d.label}</p>
                  <p className="mt-2 font-sans text-base text-navy-ink sm:text-lg">{d.value}</p>
                </div>
              </div>
            ))}
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="border border-navy-ink/10 bg-navy-light/40 p-8 backdrop-blur-md lg:col-span-7 lg:p-12"
          >
            <EnquiryForm presetInterest={presetInterest} prefix="contact" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
